export { AdmModuleCustomer as default } from './Customers';
